/**
 * ตัวชี้ไปยังการจองที่สร้างแล้วแต่ยังไม่ได้ชำระเงิน
 *
 * ตะกร้าถูกล้างทันทีที่สร้างการจอง ซึ่งถูกแล้ว -- ถ้าไม่ล้าง ลูกค้ากดย้อนกลับแล้วกดจองซ้ำ
 * จะได้การจองใบที่สองกันห้องซ้อนกัน แต่ผลข้างเคียงคือถ้ากดย้อนกลับจากหน้าชำระเงิน
 * ลูกค้าจะเจอตะกร้าว่างเปล่า ไม่รู้ว่าเกิดอะไรขึ้นและกลับไปจ่ายไม่ได้
 *
 * ตัวนี้เก็บทางกลับไว้ให้ หน้าตะกร้าจะเอาไปขึ้นแถบ "กลับไปชำระเงิน"
 */
const KEY = 'once_pending_payment';

export const setPendingPayment = (data) => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...data, savedAt: Date.now() }));
  } catch (e) {
    /* โหมดไม่ระบุตัวตนเขียนไม่ได้ -- ไม่เป็นไร แค่ไม่มีทางลัดกลับ */
  }
};

export const getPendingPayment = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    // การจองแบบนี้ถูกกันห้องไว้ไม่เกินหลักสิบนาที เก็บทางกลับไว้ 2 ชั่วโมงก็เกินพอ
    // นานกว่านั้นแปลว่าถูกยกเลิกไปแล้วแน่ๆ ไม่ต้องชวนให้กดกลับไปเจอ error
    if (!data?.id || Date.now() - (data.savedAt || 0) > 2 * 60 * 60 * 1000) {
      localStorage.removeItem(KEY);
      return null;
    }
    return data;
  } catch (e) {
    return null;
  }
};

export const clearPendingPayment = () => {
  try {
    localStorage.removeItem(KEY);
  } catch (e) { /* ignore */ }
};
